import { allOrganizationsService } from '../../../services';

export const config: any = {
  updateAllOrganisationStatus: (params: any) =>
    allOrganizationsService.updateAllOrganisationStatus(params),
  updateOrganisationStatus: (params: any) =>
    allOrganizationsService.updateOrganisationStatus(params),
  deleteOrganization: (params: any) =>
    allOrganizationsService.deleteOrganization(params),
  updateCompanySyncJob: (params: any) =>
    allOrganizationsService.updateCompanySyncJob(params),
};
